import React from 'react'
import Dashboard from '../../Compnents/Dashboard'

const DashboardScreen = () => {
    return (
        <>
        <Dashboard />
        </>
    )
}

export default DashboardScreen